import config from '../config/config';
import Hook from '../../events/Hook';
import runloop from '../../global/runloop';
import dataConfigurator from '../config/custom/data';

var shouldRerender = [ 'template', 'partials', 'components', 'decorators', 'events' ];

var completeHook = new Hook( 'complete' );
var resetHook = new Hook( 'reset' );
var renderHook = new Hook( 'render' );
var unrenderHook = new Hook( 'unrender' );

export default function Ractive$reset ( data ) {
	data = data || {};

	if ( typeof data !== 'object' ) {
		throw new Error( 'The reset method takes either no arguments, or an object containing new data' );
	}

	// TEMP need to tidy this up
	data = dataConfigurator.init( this.constructor, this, { data: data });

	var promise = runloop.start( this, true );

	// If the root object is wrapped, try and use the wrapper's reset value
	var wrapper = this.viewmodel.wrapper;
	if ( wrapper && wrapper.reset ) {
		if ( wrapper.reset( data ) === false ) {
			// reset was rejected, we need to replace the object
			this.viewmodel.set( data );
		}
	} else {
		this.viewmodel.set( data );
	}

	// reset config items and track if need to rerender
	var changes = config.reset( this );
	var rerender;

	var i = changes.length;
	while ( i-- ) {
		if ( shouldRerender.indexOf( changes[i] ) > -1 ) {
			rerender = true;
			break;
		}
	}

	if ( rerender ) {
		unrenderHook.fire( this );
		this.fragment.resetTemplate( this.template );
		renderHook.fire( this );
		completeHook.fire( this );
	}

	runloop.end();

	resetHook.fire( this, data );

	return promise;
}

//# sourceMappingURL=/home/travis/build/ractivejs/ractive/.gobble-build/01-transpile/.cache/Ractive/prototype/reset.js.map
